// Import the required Firebase modules
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Firebase configuration object
const firebaseConfig = {
  apiKey: "AIzaSyBilIrbV67JY5ptqpD-Oha951h12V87srU",
  authDomain: "gearshare-41e19.firebaseapp.com",
  projectId: "gearshare-41e19",
  storageBucket: "gearshare-41e19.firebasestorage.app",
  messagingSenderId: "201002562249",
  appId: "1:201002562249:web:31e0c7d02ae1184d885318",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Authentication
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Export the initialized services
export default app;
export { db, auth, storage };
